import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import NotFound404 from '../NotFound404';
import { ProcedureProvider } from '../../procedures/ProcedureContext';
import { getProcedureBasePath, resolveProcedureSlug } from '../../procedures/procedureRoutes';

export default function ProcedureShell() {
  const { country, procedurePath } = useParams();
  const slug = resolveProcedureSlug(country, procedurePath);
  if (!slug) return <NotFound404 />;

  const basePath = getProcedureBasePath(slug);
  return (
    <ProcedureProvider slug={slug} basePath={basePath}>
      <Outlet />
    </ProcedureProvider>
  );
}
